export const getVideoUrl = videoHost => pathname =>
  pathname && videoHost ? `https://${videoHost}/${pathname}` : '';
